import CollapsedDocumentDetailsList from '@containers/form-i9/document-details-list/collapsed';
import ExpandedDocumentDetailsList from '@containers/form-i9/document-details-list/expanded';
import { Hidden } from '@material-ui/core';
import { Section2ValidationErrors } from '@models/onboarding-review/section2-validation-errors';
import { ISection2DocumentsStore } from '@stores/onboarding-review/section2-documents-store';
import * as React from 'react';

interface IProps {
    store: ISection2DocumentsStore;
    renderAdditionalInformation: ((listForm: string) => React.ReactNode) | React.ReactNode;
    renderConditionallyAdditionalInformation: ( ( listForm: string ) => React.ReactNode ) | React.ReactNode;
    qrCodeSection: React.ReactNode;
    validationErrors: Record<Section2ValidationErrors, boolean>;
}

const FormI9DocumentDetailList: React.FunctionComponent<IProps> = props => {
    return (
        <React.Fragment>
            <Hidden implementation='js'
                    mdUp={true}>
                {/* Mobile view */}
                <CollapsedDocumentDetailsList {...props} />
            </Hidden>
            <Hidden implementation='js'
                    smDown={true}>
                {/* Tablet/Desktop view */}
                <ExpandedDocumentDetailsList {...props} />
            </Hidden>
        </React.Fragment>
    );
};

export default FormI9DocumentDetailList;



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/index.tsx